import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import ReactLoading from "react-loading";
import { UserContext } from "../App";

const Collaborator = (props) => {
  const { user } = useContext(UserContext);
  const [transactions, setTransactions] = useState([]);
  const [parentCommissions, setParentCommissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(API_BASE_URL + "/summaryCommissions", {
        params: {
          username: user?.data[0]?.UserName,
          id_type: user?.data[0]?.id_type,
          collab: "h",
        },
        headers: {
          "Content-Type": "application/json",
        },
      });

      const { transactions } = res.data;
      console.log("Transaction", res.data);
      setTransactions(transactions);
      setFilteredTransactions(transactions);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchParentCommissions = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/summaryParentCommissions", {
        params: { username: user?.data[0]?.UserName },
      });
      setParentCommissions(res.data.transactions || []);
    } catch (error) {
      setParentCommissions([]);
      console.error("Error fetching parent commissions:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchParentCommissions();
  }, [user]);

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredTransactions(transactions);
    } else {
      setFilteredTransactions(
        transactions.filter((item) =>
          item.UserName.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }
  }, [searchQuery, transactions]);

  const handleWithdraw = async (userName, totalMoney) => {
    const confirmWithdraw = window.confirm(`Bạn có chắc chắn muốn rút ${formatSurplus(totalMoney)} VNĐ cho ${userName}?`);
    if (!confirmWithdraw) return;

    try {
      setLoading(true);
      await axios.post(API_BASE_URL + "/update_commission", {
        username: userName,
        CommissionStatus: 2,
        totalMoney: totalMoney, // Truyền thêm totalMoney
      });
      setLoading(false);
      
      const confirm = window.confirm(`Đã thanh toán hoa hồng ${formatSurplus(totalMoney)} VNĐ cho ${userName}`);
      if (confirm) {
        window.location.reload();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
      alert("Lỗi khi rút tiền, vui lòng thử lại.");
    }
  };

  const handleWithdrawParentCommission = async (childUsername, totalMoney) => {
    const confirmWithdraw = window.confirm(`Bạn có chắc chắn muốn rút ${formatSurplus(totalMoney)} VNĐ hoa hồng chênh lệch từ ${childUsername}?`);
    if (!confirmWithdraw) return;

    try {
      setLoading(true);
      await axios.post(API_BASE_URL + "/update_parent_commission", {
        parentUsername: user?.data[0]?.UserName,
        childUsername,
        totalMoney,
      });
      setLoading(false);

      const confirm = window.confirm(`Đã cộng ${formatSurplus(totalMoney)} VNĐ vào tài khoản của bạn`);
      if (confirm) {
        window.location.reload();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
      alert("Lỗi khi rút hoa hồng, vui lòng thử lại.");
    }
  };

  const formatSurplus = (value) => {
    return value.toLocaleString("vi-VN");
  };

  if (loading) {
    return (
      <div className="loading-container">
        <ReactLoading type="spin" color="#000" />
      </div>
    );
  }

  const extractHeaders = (data) => {
    const excludeHeaders = ["UserName", "totalMoney"];
    return Object.keys(data)
      .filter((key) => !excludeHeaders.includes(key))
      .concat(["UserName", "totalMoney"]);
  };

  const renderTableHeaders = () => {
    const headers = extractHeaders(filteredTransactions[0] || {});
    return (
      <>
        <th key="UserName">TÊN TÀI KHOẢN</th>
        <th key="totalMoney">TỔNG TIỀN</th>
        {headers.map((header) => {
          if (header === "UserName" || header === "totalMoney") return null;
          return <th key={header}>{header.toUpperCase()}</th>;
        })}
        <th key="withdraw">RÚT TIỀN</th>
      </>
    );
  };

  const renderTableData = (sMoney) => {
    const headers = extractHeaders(filteredTransactions[0] || {});
    return (
      <>
        <td>{sMoney.UserName}</td>
        <td>{formatSurplus(sMoney.totalMoney)}</td>
        {headers.map((header, index) => {
          if (header === "UserName" || header === "totalMoney") return null;
          return <td key={index}>{formatSurplus(sMoney[header])}</td>;
        })}
        <td>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleWithdraw(sMoney.UserName, sMoney.totalMoney)}
          >
            Rút Tiền
          </button>
        </td>
      </>
    );
  };

  return (
    <div className="container">
      {/* Search Input */}
      <div className="my-4">
        <label htmlFor="searchQuery">Tìm kiếm Tài khoản:</label>
        <input
          id="searchQuery"
          type="text"
          className="form-control"
          placeholder="Nhập tên tài khoản"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Total Money Table */}
      <h2 className="text-center my-4">Tổng tiền nạp thanh toán hoa hồng cộng tác viên</h2>
      <div className="table-responsive">
        {filteredTransactions.length > 0 ? (
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>{renderTableHeaders()}</tr>
            </thead>
            <tbody>
              {filteredTransactions.map((sMoney, index) => (
                <tr key={index}>{renderTableData(sMoney)}</tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>
            Hiện tại bạn chưa có giới thiệu. Mã giới thiệu của bạn là{" "}
            <b>{user?.data[0]?.UserName}</b>
          </p>
        )}
      </div>

      {/* Hoa hồng chênh lệch (%) mà mình được hưởng khi cộng tác viên cấp dưới nạp tiền */}
      {parentCommissions.length > 0 && (
        <>
          <h2 className="text-center my-4">Hoa hồng chênh lệch từ cộng tác viên</h2>
          <div className="table-responsive">
            <table className="table table-striped table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th>TÊN TÀI KHOẢN</th>
                  <th>HOA HỒNG CHỜ RÚT</th>
                  <th>RÚT TIỀN</th>
                </tr>
              </thead>
              <tbody>
                {parentCommissions.map((item, index) => (
                  <tr key={index}>
                    <td>{item.InvitedUser}</td>
                    <td>{formatSurplus(item.totalMoney)}</td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleWithdrawParentCommission(item.InvitedUser, item.totalMoney)}
                      >
                        Rút Tiền
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default Collaborator;
